
import { Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import GoogleAutocomplete from '@/components/googleAutocomplete.vue'
import * as OM from '@/model'

@Options({})
export default class ConfirmModal extends Vue {

    @Prop() title: string;
    @Prop() text: string;
    @Prop() okText: string;
    @Prop() koText: string;
    @Prop() placeholder: string;

    @Prop({
        default: 'text'
    }) type: string;
    @Prop() value: string;
    @Prop() okCallback: (input: string) => Promise<any>;
    @Prop() koCallback: () => Promise<any>;

    localValue: string = "";

    created(){
        if(this.value){
            this.localValue = this.value;
        }
    }

    async ok(){
        if(this.okCallback){
            await this.okCallback(this.localValue);
        }
        this.$emit('close');
    }

    async ko(){
        if(this.koCallback){
            await this.koCallback();
        }
        this.$emit('close');
    }

}
